const topics = [
  { label: '暑期档必看', count: '8.6万讨论', hot: true },
  { label: '国产科幻崛起', count: '6.3万讨论', hot: true },
  { label: '经典港片修复', count: '5.1万讨论', hot: false },
  { label: '悬疑烧脑推荐', count: '4.8万讨论', hot: false },
  { label: '纪录片高分榜', count: '3.9万讨论', hot: false },
  { label: '武侠情怀回归', count: '3.5万讨论', hot: false },
  { label: '漫改真人热议', count: '2.8万讨论', hot: false },
  { label: '古装剧天花板', count: '2.4万讨论', hot: false },
  { label: '韩剧OST精选', count: '2.1万讨论', hot: false },
  { label: '动画电影专区', count: '1.9万讨论', hot: false },
  { label: '午夜档恐怖片', count: '1.6万讨论', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-100">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-primary-100 text-primary-700 mb-3 whitespace-nowrap">
            话题广场
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            热门话题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            看看大家都在讨论什么 —— 加入影视爱好者的话题圈
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((t, i) => (
            <a
              key={i}
              href="#topics"
              className={`group flex items-center gap-2 px-4 py-2.5 rounded-full transition-all cursor-pointer border whitespace-nowrap ${
                t.hot
                  ? 'bg-accent-50 border-accent-200 text-accent-800 hover:bg-accent-100'
                  : 'bg-background-50 border-background-200 text-foreground-600 hover:bg-background-200/60 hover:border-background-300'
              }`}
            >
              {t.hot && <i className="ri-fire-line text-accent-500 text-sm"></i>}
              <span className="text-sm font-medium">{t.label}</span>
              <span className={`text-xs ${t.hot ? 'text-accent-500' : 'text-foreground-400'}`}>{t.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}